import { useEffect, useState } from "react";
import { api } from "@/api/client";
import MasterCrudPage from "@/components/MasterCrudPage";
import { SearchableSelect } from "@/components/ui/searchable-select";
import { Search, X } from "lucide-react";

export default function Teams() {
  const [depts, setDepts] = useState([]);
  const [users, setUsers] = useState([]);
  const [deptFilter, setDeptFilter] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/departments").then(r => setDepts(r.data?.data || []));
    api.get("/users?limit=200").then(r => setUsers(r.data?.data || []));
  }, []);

  const deptMap = Object.fromEntries(depts.map(d => [d.id, d.name]));
  const userMap = Object.fromEntries(users.map(u => [u.id, u.name]));

  const queryParams = {
    ...(search ? { search } : {}),
    ...(deptFilter ? { department_id: deptFilter } : {}),
  };

  const filterBar = (
    <div className="erp-card p-3 flex flex-wrap items-center gap-2">
      <div className="relative min-w-[200px] flex-1 max-w-xs">
        <Search size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search teams..."
          className="erp-input pl-8 text-sm"
        />
        {search && <button onClick={() => setSearch("")} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"><X size={12} /></button>}
      </div>
      <div className="min-w-[180px]">
        <SearchableSelect
          options={depts.map(d => ({ value: d.id, label: d.name }))}
          value={deptFilter}
          onValueChange={setDeptFilter}
          placeholder="All Departments"
          allowClear
        />
      </div>
      {(search || deptFilter) && (
        <button onClick={() => { setSearch(""); setDeptFilter(""); }} className="text-xs text-slate-500 hover:text-slate-800 underline">Clear</button>
      )}
    </div>
  );

  return (
    <MasterCrudPage
      endpoint="/teams"
      title="Teams"
      breadcrumbs={["Masters", "Teams"]}
      testIdPrefix="team"
      initialForm={{ is_active: true, member_ids: [] }}
      queryParams={queryParams}
      filterBar={filterBar}
      columns={[
        { key: "code", label: "Code", width: 100 },
        { key: "name", label: "Name" },
        { key: "department_id", label: "Department", render: r => deptMap[r.department_id] || "—" },
        { key: "manager_id", label: "Manager", render: r => userMap[r.manager_id] || "—" },
        { key: "member_ids", label: "Members", render: r => (r.member_ids || []).length },
      ]}
      formFields={[
        { key: "code", label: "Code", required: true },
        { key: "name", label: "Name", required: true },
        { key: "department_id", label: "Department", type: "select",
          options: depts.map(d => ({ value: d.id, label: d.name })) },
        { key: "manager_id", label: "Manager", type: "select",
          options: users.map(u => ({ value: u.id, label: u.name })) },
        { key: "member_ids", label: "Members", type: "multi-select",
          options: users.map(u => ({ value: u.id, label: u.name })) },
        { key: "is_active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
